import { Actions, ActionTypes } from '@core/store/actions';
import { UserLoginMessage } from '@model';

export interface State {
  userLoginMessagesLoaded: boolean;
  userLoginMessagesLoading: boolean;
  userLoginMessages: UserLoginMessage[];
}

export const initialState: State = {
  userLoginMessagesLoaded: false,
  userLoginMessagesLoading: false,
  userLoginMessages: []
};

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionTypes.LoadUserLoginMessages:
      return { ...state, userLoginMessagesLoaded: false, userLoginMessagesLoading: true };

    case ActionTypes.LoadUserLoginMessagesSuccess:
      return {
        ...state,
        userLoginMessages: action.payload,
        userLoginMessagesLoaded: true,
        userLoginMessagesLoading: false
      };
    case ActionTypes.LoadUserLoginMessagesFail:
      return { ...state, userLoginMessagesLoaded: false, userLoginMessagesLoading: false };

    case ActionTypes.LoginMessageSetAsRead:
      return { ...state, userLoginMessagesLoaded: false, userLoginMessagesLoading: true };

    case ActionTypes.LoginMessageSetAsReadSuccess:
      if (state.userLoginMessages.length === 0) {
        return {
          ...state,
          userLoginMessagesLoaded: true,
          userLoginMessagesLoading: false,
          userLoginMessages: [action.payload]
        };
      }

      let newList = state.userLoginMessages.map(m => {
        if (m.id === action.payload.id) {
          return action.payload;
        }
        return m;
      });

      return { ...state, userLoginMessagesLoaded: true, userLoginMessagesLoading: false, userLoginMessages: newList };

    case ActionTypes.LoginMessageSetAsReadFail:
      return { ...state, userLoginMessagesLoaded: false, userLoginMessagesLoading: false };
  }
  return state;
}

export const getUserLoginMessages = (state: State) => state.userLoginMessages;
export const getUserLoginMessagesLoaded = (state: State) => state.userLoginMessagesLoaded;
